import { memo, useEffect, useRef, useCallback } from "react";

const AppDialog = ({ open, title, children, onClose, DialogContentProps, style, className, zIndex = 1055, ...otherProps }) => {
  const modalRef = useRef(null);

  const handleKeyDown = useCallback((e) => {
    if (e.key === "Escape" && onClose) {
      onClose(e, "escapeKeyDown");
    }
  }, [onClose]);

  useEffect(() => {
    if (open) {
      document.body.classList.add("modal-open");
      document.addEventListener("keydown", handleKeyDown);
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, handleKeyDown]);

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: zIndex - 5 }} onClick={e => onClose && onClose(e, "backdropClick")}></div>
      <div
        ref={modalRef}
        className="modal modal-blur fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, marginLeft: 0, zIndex }}
      >
        <div
          className={`modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable ${className || ""}`}
          role="document"
          style={style}
          {...otherProps}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title || ""}</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={e => onClose && onClose(e, "backdropClick")}
              ></button>
            </div>
            <div className="modal-body" {...DialogContentProps}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(AppDialog);
